export default __webpack_public_path__ + "static/media/loader-faturamento.9e9982d7.gif";